import Searchbar from "./searchbar";
import SearchSheet from "./searchSheet";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "./ui/loading-spinner";
import { Console } from "console";
import AmicusSheet from "./amicusSheet";
import { AmicusFile } from "@/lib/conflix";

function SearchMenu(props: {idToken: string, setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>, setAmicusFile: React.Dispatch<React.SetStateAction<AmicusFile | null>>}) {
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [companyName, setCompanyName] = useState<string>("");
    const [refNum, setRefNum] = useState<string>("");
    const [loading, setLoading] = useState<number>(0);
    const [amicusLoading, setAmicusLoading] = useState<number>(1);

    const search = (ref: string, first: string, last: string, company: string) => {
        if (!first && !last && !company && !ref) {
            return;
        }
        setFirstName(lastName => first);
        setLastName(lastName => last);
        setCompanyName(companyName => company);
        setRefNum(refNum => ref);
        setLoading(prev => prev + 1);
        setAmicusLoading(prev => prev + 1);
    }

    return (
        <div className="search-menu">
            <Searchbar search={search} />
            <SearchSheet key={loading} idToken={props.idToken} query={`?first-name-search=${firstName}&last-name-search=${lastName}&company-name-search=${companyName}&reference-number-search=${refNum}`} />
            <AmicusSheet key={amicusLoading} setDialogOpen={props.setDialogOpen} usingRefNum={refNum !== ""} setAmicusFile={props.setAmicusFile} idToken={props.idToken} query={firstName || lastName || companyName ? `?firstName=${firstName}&lastName=${lastName}&companyName=${companyName}` : ""}/>
        </div>
    )
}

export default SearchMenu;